import { FlaskConical, Users, Award, ShieldCheck } from "lucide-react";
import { useLanguage } from "@/lib/i18n";
import { useScrollReveal } from "@/hooks/useScrollReveal";

export function TrustStrip() {
  const { t } = useLanguage();
  const { ref, isVisible } = useScrollReveal();

  const items = [
    { icon: FlaskConical, key: 'trust.clinicallyTested' },
    { icon: Users, key: 'trust.happyCustomers' },
    { icon: Award, key: 'trust.labFormula' },
    { icon: ShieldCheck, key: 'trust.moneyBack' },
  ];

  return (
    <section className="py-6 md:py-8 bg-white" aria-label="Trust indicators">
      <div ref={ref} className={`container scroll-reveal ${isVisible ? 'visible' : ''}`}>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {items.map(({ icon: Icon, key }) => (
            <div
              key={key}
              className="flex items-center gap-2.5 p-3 md:p-4 rounded-xl border border-border/50 bg-white/80"
            >
              <div className="w-9 h-9 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Icon className="w-4 h-4 text-primary" />
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground leading-tight">
                {t(key)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
